<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.competition }}
              </h6>
              <div class="element-box-tp">

                <div class="alert" v-if="status > 200">
								<span v-if="status == 401">
									{{ t.error.access_denied_content }}
								</span>
                  <span v-if="status == 404">
									{{ t.error.notfound_content_list }}
								</span>
                </div>
                <div class="pull-left p-2 w150">
                  <input type="number" class="form-control" v-model="competitionId" placeholder="ID"/>
                </div>
                <div class="pull-right p-2 w150">
                  <input type="text" class="form-control" v-model="competitionName"/>
                </div>
                <div class="pull-right p-2 w150">
                  <select name="x" class="form-control" v-model="provider">
                    <option v-for="p in providers" :value="p.id">{{ p.name }}</option>
                  </select>
                </div>

                <div class="pull-right p-2 w150">
                  <select name="x" class="form-control" v-model="allClass">
                    <option v-for="c in classes" :value="c.id">{{ c.name }}</option>
                  </select>
                </div>
                <table class="table table-bordered table-lg table-v2 table-striped">
                  <thead>
                  <tr>
                    <th>
                      <select class="choicesx form-control form-control-sm form-control-faded" v-model="sport">
                        <option :value="sport.id" v-for="sport in sports">{{ sport.name }}</option>
                      </select>
                    </th>
                    <th>
                      <div class="text-left">
                        <autocomplete v-if="regions"
                                      input-class="form-control"
                                      @selected="setRegion"
                                      @clear="deleteRegion"
                                      :source="Object.values(regions)">
                        </autocomplete>
                      </div>
                    </th>
                    <th>

                    </th>
                    <th>
                      Risk management
                    </th>
                    <th>
                      <input type="checkbox" v-model="allActive" @change="activeAll"/>
                    </th>
                    <th>
                      <input type="checkbox" @change="checkAll" />
                    </th>
                  </tr>
                  </thead>
                  <draggable v-model="competitions" @end="moved" :element="'tbody'">
                    <tr v-for="row in competitions">
                      <td class="w150">
                        #{{ row.id }}
                      </td>
                      <td>
                        <div class="input-group" v-tooltip="row.provider.name">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <flag :iso="row.region.code" :squared="false"/>
                            </div>
                          </div>
                          <input class="form-control" v-model="row.name" @change="moved">
                        </div>
                      </td>
                      <td>
                        <select name="x" class="form-control" @change="moved" v-if="row.class" v-model="row.class.id">
                          <option v-for="c in classes" :value="c.id">{{ c.name }}</option>
                        </select>
                      </td>
                      <td class="w100">
                        <div id="toggles" class="pull-right" v-tooltip="'is Active'">
                          <input type="checkbox" class="ios-toggle" :id="'is'+row.id" v-model="row.isActive" @change="moved" />
                          <label :for="'is'+row.id"  class="checkbox-label"></label>
                        </div>
                      </td>
                      <td class="w100 text-center">
                        <input type="checkbox" v-model="row.checked" />
                      </td>
                    </tr>
                  </draggable>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--------------------
START - Sidebar
-------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>
        <div class="element-wrapper">
          <div class="element-actions actions-only" >

          </div>
          <h6 class="element-header" >

          </h6>
          <div class="element-box-tp">

          </div>
        </div>

      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>
  </div>
</template>

<script>

  import draggable from 'vuedraggable'
  import Autocomplete from 'vuejs-auto-complete'
  import templateSelector from '@/components/feed/element/templateSelector'
  import feed from '@/mixins/feed.js'

  export default {
    name: 'CompetitionList',
    components: {Autocomplete, templateSelector, draggable},
    mixins: [feed],
    data () {
      return {
        t: this.$root.t,
        status: 0,
        sport: 1,
        markets: [],
        sports: [],
        regions: [],
        region: 0,
        competition: 0,
        competitions: [],
        classes: [],
        selected: [],
        allClass: 0,
        allActive: false,
        providers: [],
        provider: [],
        isLoading: true,
        competitionName: '',
        competitionId: 0
      }
    },
    watch: {
      'allClass' () {
        this.editAllCompetionClass();
      },
      sport () {
        this.fetchRegions()
      },
      region () {
        this.fetchCompetitions()
      },
      provider () {
        this.fetchCompetitions()
      },
      competitionName () {
        this.fetchCompetitions()
      },
      competitionId () {
        this.fetchCompetitions()
      }
    },
    mounted () {

      this.fetchAllClass().then(response => {
        response.body.forEach((e) => {
          this.classes.push({name: e.name, id: e.id})
        });

        this.fetchProviders();

      });

      this.fetchSports();
      this.fetchRegions();
      this.fetchCompetitions();
    },
    methods: {
      activeAll () {
        this.competitions.forEach((c) => {
          c.isActive = this.allActive;
        });
        this.moved();
      },
      editAllCompetionClass() {
        this.competitions.forEach((c) => {
          if(c.checked)
            c.class.id = this.allClass;
        });
        this.moved();
      },
      checkAll () {
        this.competitions.forEach((c) => {
          c.checked = (c.checked) ? false : true;
        });
      },
      moved() {
          this.editCompetition({data: this.competitions});
      },
      fetchProviders () {
        this.$http.get(bsapi+'api/v1/fixture/providers').then(response => {
          // get body data

            this.providers = response.body;
        }, response => {
        })
      },
      orderEvent() {
        this.$bus.$emit('globalLoader', true);
        this.$http.post(bsapi+'api/v1/match/events/order', {events: this.events}).then(response => {

          this.$bus.$emit('globalLoader', false);
        }, response => {
          this.$bus.$emit('globalLoader', false);

        })
      },
      fetchSports () {
        this.$http.get(api+'api/v1/fixture/sport?per_page=99999999').then(response => {
          // get body data
          this.sports = response.body.result.sport;

        }, response => {
          this.isLoading = false;
        })
      },
      fetchRegions () {
        this.$http.get(bsapi+'api/v1/fixture/region?per_page=99999999&sport='+this.sport).then(response => {
          // get body data
          this.regions = response.body.result.region;

        }, response => {
          this.isLoading = false;
        })
      },
      fetchCompetitions () {
        var ID = (this.competitionId > 0) ? '&competition[]='+this.competitionId : '';
        this.$http.get(api+'api/v1/fixture/competition?per_page=99999999&sport[]='+this.sport+'&region[]='+this.region+'&provider='+this.provider+'&name='+this.competitionName+ID).then(response => {
          // get body data
          this.competitions = Object.values(response.body.result.competition);

          this.status = response.status;
        }, response => {
          this.isLoading = false;
          this.status = response.status;
        })
      },
      setCompetition (c) {
        this.competition = c.value;
      },
      setRegion (r) {
        this.region = r.value;
      },
      deleteCompetition (c) {
        this.competition = 0;
      },
      deleteRegion (r) {
        this.region = 0;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/competition/list.vue